// Chat-window font options. Each 'value' is 'RealSystemFont, OpenSubstitute, generic'.
// The system fonts (Arial, Impact, Georgia, ...) render only where the OS has them installed;
// Android ships none of them, so a chosen font used to fall back to the default there.
// The middle name in each stack is a free, self-hosted open font (see fonts.scss in apps/webclient
// and apps/frontend) that is downloaded on demand - so desktop/iOS show the genuine font and
// Android shows a metric- or visually-close substitute instead of the default.
// Why we self-host substitutes at all: docs/fonts/README.md
// Real vs substitute comparison (open in a browser): docs/fonts/font-substitutes-comparison.html
export const FONT_DEFINITIONS = [
  {
    value: 'Arial, Arimo, sans-serif',
    description: 'Arial (Default)',
  },
  {
    value: '"Book Antiqua", "PT Serif", serif',
    description: 'Book Antiqua',
  },
  {
    value: '"Brush Script MT", Pacifico, cursive',
    description: 'Brush Script MT',
  },
  {
    value: 'Calibri, "Open Sans", sans-serif',
    description: 'Calibri',
  },
  {
    value: '"Comic Sans MS", "Comic Neue", cursive',
    description: 'Comic Sans MS',
  },
  {
    value: 'Consolas, "Roboto Mono", monospace',
    description: 'Consolas',
  },
  {
    value: '"Courier New", Cousine, monospace',
    description: 'Courier New',
  },
  {
    value: 'Garamond, "EB Garamond", serif',
    description: 'Garamond',
  },
  {
    value: 'Georgia, Gelasio, serif',
    description: 'Georgia',
  },
  {
    value: 'Helvetica, Arimo, sans-serif',
    description: 'Helvetica',
  },
  {
    value: '"Helvetica Neue", Arimo, sans-serif',
    description: 'Helvetica Neue',
  },
  {
    value: 'Impact, Anton, sans-serif',
    description: 'Impact',
  },
  {
    value: '"Lucida Grande", Lato, sans-serif',
    description: 'Lucida Grande',
  },
  {
    value: 'Menlo, "Roboto Mono", monospace',
    description: 'Menlo',
  },
  {
    value: 'Monaco, "Roboto Mono", monospace',
    description: 'Monaco',
  },
  {
    value: 'Palatino, "PT Serif", serif',
    description: 'Palatino',
  },
  {
    value: '"Segoe UI", "Open Sans", sans-serif',
    description: 'Segoe UI',
  },
  {
    value: 'system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
    description: 'System Default',
  },
  {
    value: 'Tahoma, "Open Sans", sans-serif',
    description: 'Tahoma',
  },
  {
    value: '"Times New Roman", Tinos, serif',
    description: 'Times New Roman',
  },
  {
    value: '"Trebuchet MS", Lato, sans-serif',
    description: 'Trebuchet MS',
  },
  {
    value: 'Verdana, "Open Sans", sans-serif',
    description: 'Verdana',
  },
];
